// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Cubic_11_1.013_R.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Cubic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
html,
body {
  background-color: rgba(199, 199, 199, 0.9098039216);
  font-family: Cubic;
  margin: 0;
  height: 100%;
}

#root {
  height: 100%;
}

.home {
  background-color: rgba(0, 0, 0, 0.9098039216);
  min-height: calc(100vh - 50px);
  padding-bottom: 30px;
}
.home .home-panel {
  margin-left: 50px;
  height: 480px;
}
.home .home-panel .home-info {
  color: #fff;
  margin-bottom: 80px;
  width: 200px;
}
.home .home-panel .home-info h3 {
  font-weight: 500;
}
.home .home-panel .home-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-top: 60px;
}
.home .home-panel .home-btn .home-btn-roll button {
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  width: 50px;
  height: 50px;
  border: 3px solid #ffffff;
  border-radius: 5px;
  color: #ffffff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home .home-panel .home-btn .home-btn-roll button:hover {
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.9098039216);
  transition: all 0.3s;
}
.home .home-panel .home-btn .home-btn-roll button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.home .home-panel .home-btn .home-btn-signup,
.home .home-panel .home-btn .home-btn-play {
  width: 80px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.9098039216);
  border: 3px solid #ffffff;
  border-radius: 5px;
  font-size: 14px;
}
.home .home-panel .home-btn .home-btn-signup:hover,
.home .home-panel .home-btn .home-btn-play:hover {
  background-color: #ffffff;
}
.home .home-panel .home-btn .home-btn-signup a,
.home .home-panel .home-btn .home-btn-play a {
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home .home-panel .home-btn .home-btn-signup a:hover,
.home .home-panel .home-btn .home-btn-play a:hover {
  color: rgba(0, 0, 0, 0.9098039216);
  font-weight: 700;
  font-size: 16px;
  transition: all 0.5s;
}

.keyboard {
  display: grid;
  grid-template-rows: 55px;
  grid-template-columns: repeat(8, 25px);
  grid-row-gap: 20px;
  justify-items: space-between;
  align-items: center;
  margin: auto;
}
.keyboard div {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  border-bottom: 5px solid rgba(199, 199, 199, 0.9098039216);
}
.keyboard .arrow {
  font-weight: 700;
  width: 50px;
  height: 50px;
}
.keyboard .arrow-left {
  grid-column-start: 2;
}
.keyboard .arrow-right {
  grid-column-start: 6;
}
.keyboard .space {
  width: 200px;
  height: 50px;
  grid-column-start: 1;
}

.header {
  background-color: rgba(0, 0, 0, 0.9098039216);
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .header-container {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .header-container a {
  color: rgba(255, 255, 255, 0.9098039216);
  font-size: 25px;
  cursor: pointer;
  text-decoration: none;
}
.header .header-container a span {
  margin-left: 10px;
}
.header .header-container div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .header-container div img {
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-right: 15px;
}
.header .header-container div span {
  color: rgba(255, 255, 255, 0.9098039216);
  font-size: 20px;
  margin-right: 40px;
  cursor: default;
}
.header .header-container div button {
  border: 0;
  background-color: rgba(0, 0, 0, 0);
}
.header .header-container div button i {
  color: rgba(255, 255, 255, 0.9098039216);
  font-size: 30px;
  cursor: pointer;
}
.header .header-container div a i {
  color: rgba(255, 255, 255, 0.9098039216);
  font-size: 30px;
  cursor: pointer;
}

#game-window {
  width: 640px;
  height: 480px;
  border: 5px solid black;
  position: relative;
}
#game-window .game-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9098039216);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 10;
}
#game-window .game-loading-blocks {
  display: flex;
  gap: 8px;
}
#game-window .game-loading-blocks span {
  display: block;
  width: 16px;
  height: 16px;
  background: #fff;
  animation: pixel-bounce 0.6s ease-in-out infinite;
}
#game-window .game-loading-blocks span:nth-child(2) {
  animation-delay: 0.15s;
}
#game-window .game-loading-blocks span:nth-child(3) {
  animation-delay: 0.3s;
}
#game-window .game-loading-text {
  font-family: Cubic, serif;
  font-size: 24px;
  color: #c7c7c7;
  margin-top: 16px;
  letter-spacing: 2px;
}
@keyframes pixel-bounce {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-12px);
    opacity: 1;
  }
}
#game-window #score {
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: Cubic, serif;
  font-size: 32px;
  color: white;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
}
#game-window #score img {
  width: 45px;
  height: 45px;
  margin-right: 5px;
}
#game-window #score div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}
#game-window #score div span {
  margin: 0 5px;
}
#game-window #score div p {
  margin: 0;
}
#game-window #score div .score-slash {
  font-size: 20px;
  padding-top: 10px;
}

#editor-window {
  width: 736px;
  height: 480px;
  border: 5px solid black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  position: relative;
}
#editor-window #save-hint {
  position: absolute;
  font-size: 48px;
  color: #fff;
  left: 96px;
  width: 640px;
  height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-edit {
  display: flex;
  position: relative;
  width: 100%;
}

.container-btn-group {
  height: 480px;
}
.container-btn-group .container-btn {
  height: 32px;
  width: 32px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  background-color: #4b4b4b;
  margin-top: 15px;
  position: relative;
}
.container-btn-group .container-btn:hover {
  background-color: #343434;
}
.container-btn-group .container-btn:active {
  background-color: #161616;
}
.container-btn-group .container-btn img {
  height: 20px;
  width: 20px;
}
.container-btn-group .container-btn .tooltiptext {
  width: 50px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.555);
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  left: 120%;
  opacity: 0;
  transition: opacity 0.8s;
  visibility: hidden;
  font-family: Cubic;
}
.container-btn-group .container-btn .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent rgba(0, 0, 0, 0.555) transparent transparent;
}
.container-btn-group .container-btn:hover .tooltiptext {
  opacity: 1;
  visibility: visible;
}

.game-info {
  margin-right: 30px;
  height: 480px;
  width: 200px;
  color: #343434;
}
.game-info h1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.game-info h3 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4b4b4b;
}
.game-info .game-refresh {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}
.game-info .game-refresh button {
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  font-size: 32px;
  color: #4b4b4b;
}
.game-info .game-refresh button:hover {
  color: #343434;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.section .close .navbar-link-title, .section .open .navbar-link-title, .section .close .navbar-link, .section .open .navbar-link {
  font-size: 20px;
  font-weight: 700;
  color: #4b4b4b;
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 40px;
}
.section .close .navbar-link-title:hover, .section .open .navbar-link-title:hover, .section .close .navbar-link:hover, .section .open .navbar-link:hover {
  color: rgba(255, 255, 255, 0.9098039216);
  background-color: #4b4b4b;
}
.section .close .navbar-link-title span, .section .open .navbar-link-title span, .section .close .navbar-link span, .section .open .navbar-link span {
  font-size: 30px;
  margin-left: 10px;
}

.section {
  display: flex;
  min-height: calc(100vh - 50px);
}
.section .close, .section .open {
  background-color: #ffffff;
  width: 200px;
  height: 100%;
  display: flex;
  flex-grow: 1;
  box-shadow: 3px 0 5px 1px rgba(113, 113, 113, 0.5);
  position: fixed;
  z-index: 1;
}
.section .close .navbar-link-title, .section .open .navbar-link-title {
  font-size: 30px;
}
.section .close ul, .section .open ul {
  list-style: none;
  padding: 0;
  width: 100%;
}
.section .close ul li, .section .open ul li {
  height: 50px;
}
.section .close div, .section .open div {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
  border-radius: 0 10px 10px 0;
  height: 50px;
  width: 30px;
  position: absolute;
  left: 200px;
  top: calc(50% - 50px);
  color: #4b4b4b;
  background-color: #ffffff;
  box-shadow: 5px 0 5px 1px rgba(113, 113, 113, 0.5);
  transition: all 0.3s;
}
.section .close div:hover, .section .open div:hover {
  width: 40px;
  transition: all 0.3s;
}
.section .open {
  transform: translateX(0px);
  transition: all 0.5s;
}
.section .close {
  transform: translateX(-200px);
  transition: all 0.5s;
}

.container {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sign-form {
  width: 370px;
  height: 420px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 0 5px 1px rgba(113, 113, 113, 0.5);
  padding: 30px;
}
.sign-form > div {
  display: flex;
  justify-content: center;
  align-items: end;
  margin-bottom: 15px;
}
.sign-form > div h1 {
  font-size: 30px;
  margin: 0;
}
.sign-form > div p {
  margin: 0 10px;
}
.sign-form > div .form-link {
  color: #4b4b4b;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
  margin: 0;
}
.sign-form > div .form-link:hover {
  font-weight: 600;
  color: black;
}
.sign-form > p {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(212, 0, 0);
}
.sign-form > p i {
  margin: 0 5px;
}
.sign-form form {
  flex-direction: column;
  height: 365px;
  width: 280px;
  margin: auto;
}
.sign-form form label {
  position: relative;
}
.sign-form form label p {
  width: 240px;
  margin: 10px 0 5px 10px;
  font-size: 14px;
}
.sign-form form label .tooltiptext {
  width: 180px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.555);
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: 30px;
  left: 290px;
  font-family: Cubic;
}
.sign-form form label .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent rgba(0, 0, 0, 0.555) transparent transparent;
}
.sign-form form label .input-box {
  position: relative;
}
.sign-form form label .input-box input {
  height: 35px;
  width: 246px;
  border-radius: 10px;
  border-color: rgba(199, 199, 199, 0.9098039216);
  padding: 0px 15px;
  font-size: 16px;
  font-family: Cubic;
}
.sign-form form label .input-box i {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #4b4b4b;
}
.sign-form form label span {
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 12px;
  color: rgb(212, 0, 0);
  margin-top: 5px;
}
.sign-form form label span i {
  margin: 0 5px;
}
.sign-form form .form-link-pw {
  width: 250px;
  margin: 5px 15px;
  display: flex;
  justify-content: end;
  align-items: center;
}
.sign-form form .form-link-pw a {
  color: #4b4b4b;
  text-decoration: none;
  font-size: 12px;
}
.sign-form form .form-link-pw a:hover {
  text-decoration: underline;
}
.sign-form form .form-btn-other, .sign-form form .form-btn-disabled, .sign-form form .form-btn {
  height: 40px;
  width: 280px;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  font-family: Cubic;
  margin: 20px 0 0 0;
}
.sign-form form .form-btn {
  background-color: rgba(0, 0, 0, 0.9098039216);
  color: rgba(255, 255, 255, 0.9098039216);
}
.sign-form form .form-btn:hover {
  background-color: #343434;
}
.sign-form form .form-btn:active {
  background-color: #161616;
}
.sign-form form .form-btn-disabled {
  background-color: rgba(199, 199, 199, 0.9098039216);
  color: #fff;
  cursor: auto;
}
.sign-form form .form-btn-other {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(0, 0, 0, 0.9098039216);
  background-color: #fff;
  color: rgba(0, 0, 0, 0.9098039216);
  font-weight: 600;
}
.sign-form form .form-btn-other:hover {
  background-color: rgba(199, 199, 199, 0.9098039216);
}
.sign-form form .form-btn-other img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.project-title {
  margin-top: 50px;
}

.project-list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 210px;
  grid-gap: 20px;
  max-height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  padding-left: 50px;
}
.project-list::-webkit-scrollbar {
  width: 10px;
  background: #9e9e9e;
}
.project-list::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #343434;
}
.project-list li {
  background-color: #fff;
  width: 200px;
  height: 200px;
  border: 2px solid black;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 3px 5px 1px rgba(113, 113, 113, 0.5);
}
.project-list li a {
  text-decoration: none;
  color: black;
}
.project-list li a .project-img {
  width: 100%;
  height: 150px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  position: relative;
}
.project-list li a .project-img .img-icon {
  position: absolute;
  top: 64px;
  left: 84px;
  visibility: hidden;
}
.project-list li a .project-img .img-main {
  width: 100%;
  height: 100%;
}
.project-list li a .project-name {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
}
.project-list li:hover {
  box-shadow: none;
  background-color: black;
  margin-top: 3px;
  margin-bottom: -3px;
}
.project-list li:hover a {
  text-decoration: none;
  color: #fff;
}
.project-list li:hover a .project-img .img-main {
  opacity: 0.5;
}
.project-list li:hover a .project-img .img-icon {
  visibility: visible;
}
.project-list li button {
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  border-radius: 8px;
  font-size: 32px;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.publish-switch .publish-title i, #edit-panel form > div label i {
  margin-right: 5px;
  font-size: 12px;
  position: relative;
}
.publish-switch .publish-title i .tooltiptext, #edit-panel form > div label i .tooltiptext {
  width: 150px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.555);
  color: #fff;
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: -12px;
  right: 200%;
  opacity: 0;
  transition: opacity 0.8s;
  visibility: hidden;
  font-family: Cubic;
}
.publish-switch .publish-title i .tooltiptext::after, #edit-panel form > div label i .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent rgba(0, 0, 0, 0.555);
}
.publish-switch .publish-title i:hover .tooltiptext, #edit-panel form > div label i:hover .tooltiptext {
  opacity: 1;
  visibility: visible;
}

#edit-panel {
  position: absolute;
  right: 0;
  width: 200px;
  height: 100%;
  color: #4b4b4b;
  background-color: #fff;
  box-shadow: -1px 0 5px 1px rgba(113, 113, 113, 0.5);
}
#edit-panel h2 {
  color: #343434;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
}
#edit-panel form {
  width: 80%;
  margin: auto;
}
#edit-panel form > div {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
#edit-panel form > div label {
  font-weight: 700;
  font-size: 16px;
}
#edit-panel form > div input {
  width: 100px;
  margin-top: 10px;
  font-family: Cubic;
}
#edit-panel .edit-delete {
  position: absolute;
  bottom: 30px;
  right: 40px;
}
#edit-panel .edit-delete button {
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  font-weight: 700;
  color: rgb(212, 0, 0);
  background-color: rgba(199, 199, 199, 0.9098039216);
  height: 30px;
  width: 120px;
  border-radius: 8px;
  box-shadow: 0 1px 1px 1px rgba(113, 113, 113, 0.5);
}
#edit-panel .edit-delete button:hover {
  color: #fff;
  background-color: rgb(212, 0, 0);
  box-shadow: none;
  margin-top: 2px;
}
#edit-panel .delete-window {
  position: fixed;
  top: calc(50% - 72px);
  left: calc(50% - 172px);
  background-color: rgba(0, 0, 0, 0.9098039216);
  color: #fff;
  border: 3px solid #fff;
  width: 350px;
  height: 150px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 3px 5px 1px rgba(113, 113, 113, 0.5);
}
#edit-panel .delete-window .delete-close {
  position: absolute;
  top: calc(50% - 60px);
  left: calc(50% + 150px);
  cursor: pointer;
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  color: #fff;
}
#edit-panel .delete-window .delete-btns {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 20px;
}
#edit-panel .delete-window .delete-btns button {
  color: #fff;
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  width: 100px;
  height: 20px;
  border-radius: 3px;
}
#edit-panel .delete-window .delete-btns .delete-yes {
  color: rgb(212, 0, 0);
  font-weight: 700;
}
#edit-panel .delete-window .delete-btns .delete-yes:hover {
  background-color: rgb(212, 0, 0);
  color: #fff;
}
#edit-panel .delete-window .delete-btns .delete-no:hover {
  background-color: #4b4b4b;
  color: #fff;
}

.publish-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 25px;
}
.publish-switch .publish-title {
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 16px;
}
.publish-switch .onoffswitch {
  position: relative;
  width: 100px;
}
.publish-switch .onoffswitch input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.publish-switch .onoffswitch label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #9e9e9e;
  border-radius: 20px;
}
.publish-switch .onoffswitch label .onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}
.publish-switch .onoffswitch label .onoffswitch-inner:before, .publish-switch .onoffswitch label .onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 30px;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
  color: white;
  font-weight: bold;
  box-sizing: border-box;
}
.publish-switch .onoffswitch label .onoffswitch-inner:before {
  content: "Public";
  padding-left: 15px;
  background-color: #1099bb;
  color: #FFFFFF;
}
.publish-switch .onoffswitch label .onoffswitch-inner:after {
  content: "Draft";
  padding-right: 15px;
  background-color: #EEEEEE;
  color: #4b4b4b;
  text-align: right;
}
.publish-switch .onoffswitch label .onoffswitch-switch {
  display: block;
  width: 18px;
  margin: 6px;
  background: #FFFFFF;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 64px;
  border: 2px solid #9e9e9e;
  border-radius: 20px;
  transition: all 0.3s ease-in 0s;
}
.publish-switch .onoffswitch input:checked + label .onoffswitch-inner {
  margin-left: 0;
}
.publish-switch .onoffswitch input:checked + label .onoffswitch-switch {
  right: 0px;
}
.publish-switch .publish-copy button {
  margin: 0;
  border: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  font-family: "Cubic";
  background-color: rgba(0, 0, 0, 0);
  font-weight: 700;
  font-size: 12px;
  color: #1099bb;
}
.publish-switch .publish-copy button:hover {
  border-bottom: 2px solid #1099bb;
}
.publish-switch .publish-copy button span i {
  margin-left: 5px;
}
.publish-switch .publish-copy .copied {
  margin-top: 15px;
  color: #4b4b4b;
}
.publish-switch .publish-copy .copied:hover {
  border: 0;
  cursor: default;
}
.publish-switch .publish-copy .appear {
  opacity: 1;
  margin-top: 15px;
  transition: opacity 0.5s, margin 0.5s;
}
.publish-switch .publish-copy .disappear {
  opacity: 0;
  transition: visibility 0.5s, opacity 0.5s, margin 0.5s;
  visibility: hidden;
}

.videobox {
  position: relative;
  width: 60%;
  height: 0;
  padding-bottom: 33.75%;
}

.videobox iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 960px) {
  .container.home {
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }
  .home .home-panel {
    margin-left: 0;
    margin-top: 20px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .home .home-panel .home-info {
    text-align: center;
    margin-bottom: 30px;
  }
  .home .home-panel .home-btn {
    margin-top: 30px;
  }
}
@media (max-width: 680px) {
  #game-window {
    width: 100%;
    max-width: 640px;
    height: auto;
    aspect-ratio: 640/480;
  }
  #game-window canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
@media (max-width: 600px) {
  .header .header-container {
    width: 95%;
  }
  .header .header-container a {
    font-size: 20px;
  }
  .header .header-container a span {
    margin-left: 5px;
  }
  .header .header-container div span {
    font-size: 14px;
    margin-right: 10px;
  }
  .header .header-container div img {
    height: 24px;
    width: 24px;
    margin-right: 8px;
  }
}
@media (max-width: 1100px) {
  .project-list {
    grid-template-columns: repeat(3, 1fr);
    padding-left: 30px;
  }
}
@media (max-width: 800px) {
  .project-list {
    grid-template-columns: repeat(2, 1fr);
    padding-left: 20px;
  }
}
@media (max-width: 500px) {
  .project-list {
    grid-template-columns: 1fr;
    padding-left: 10px;
  }
  .project-list li {
    width: 180px;
  }
}
@media (max-width: 480px) {
  .sign-form {
    width: calc(100vw - 80px);
    padding: 20px;
  }
  .sign-form form {
    width: 100%;
  }
  .sign-form form .form-btn, .sign-form form .form-btn-disabled, .sign-form form .form-btn-other {
    width: 100%;
  }
  .sign-form form label .input-box input {
    width: calc(100% - 30px);
  }
}
@media (max-width: 800px) {
  .container-edit {
    overflow-x: auto;
  }
}
@media (max-width: 700px) {
  .section .open, .section .close {
    position: fixed;
    z-index: 10;
    height: 100%;
  }
}
@media (max-width: 400px) {
  .keyboard {
    grid-template-columns: repeat(8, 20px);
  }
  .keyboard .arrow {
    width: 40px;
    height: 40px;
  }
  .keyboard .space {
    width: 160px;
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./public/main.scss","webpack://./public/scss/home.scss","webpack://./public/scss/header.scss","webpack://./public/scss/canvas.scss","webpack://./public/scss/section.scss","webpack://./public/scss/form.scss","webpack://./public/scss/project.scss","webpack://./public/scss/editPanel.scss","webpack://./public/scss/tutorial.scss","webpack://./public/scss/responsive.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,4CAAA;AACJ;AAiCA;;EAEI,mDAjCe;EAkCf,kBAAA;EACA,SAAA;EACA,YAAA;AA/BJ;;AAkCA;EACI,YAAA;AA/BJ;;ACdA;EACI,6CDKc;ECJd,8BAAA;EACA,oBAAA;ADiBJ;ACfI;EACI,iBAAA;EACA,aAAA;ADiBR;ACfQ;EACI,WAAA;EACA,mBAAA;EACA,YAAA;ADiBZ;ACfY;EACI,gBAAA;ADiBhB;ACbQ;EDEJ,aAAA;EACA,8BCFwB;EDGxB,mBAH0B;ECClB,YAAA;EACA,gBAAA;ADiBZ;ACdgB;EDEZ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;ECNgB,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cDvBF;ECwBE,eAAA;EDXhB,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAqC9B;ACtBoB;EACI,yBD5BN;EC6BM,kCD/BN;ECgCM,oBAAA;ADwBxB;ACrBoB;EACI,YAAA;EACA,mBAAA;ADuBxB;AClBY;;EAEI,WAAA;EACA,YAAA;EACA,6CD9CE;EC+CF,yBAAA;EACA,kBAAA;EACA,eAAA;ADoBhB;AClBgB;;EACI,yBDlDF;AAuElB;AClBgB;;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,cDzDF;EAad,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAqE9B;ACrBoB;;EACI,kCD/DN;ECgEM,gBAAA;EACA,eAAA;EACA,oBAAA;ADwBxB;;ACfA;EACI,aAAA;EACA,wBAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,YAAA;ADkBJ;AChBI;EACI,sBAAA;EACA,mBAAA;EDvEJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EC0EtB,eAAA;EACA,0DAAA;ADoBR;ACjBI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;ADmBR;AChBI;EACI,oBAAA;ADkBR;ACfI;EACI,oBAAA;ADiBR;ACdI;EACI,YAAA;EACA,YAAA;EACA,oBAAA;ADgBR;;AEnIA;EACI,6CFKc;EEJd,WAAA;EACA,YAAA;EFkBA,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAwH9B;AEtII;EACI,UAAA;EFcJ,aAAA;EACA,8BEdoB;EFepB,mBAH0B;AA8H9B;AExIQ;EACI,wCFJG;EEKH,eAAA;EACA,eAAA;EACA,qBAAA;AF0IZ;AExIY;EACI,iBAAA;AF0IhB;AEtIQ;EFAJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;AA4I9B;AExIY;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AF0IhB;AEvIY;EACI,wCFzBD;EE0BC,eAAA;EACA,kBAAA;EACA,eAAA;AFyIhB;AEtIY;EACI,SAAA;EACA,kCAAA;AFwIhB;AEtIgB;EACI,wCFpCL;EEqCK,eAAA;EACA,eAAA;AFwIpB;AEnIgB;EACI,wCF5CL;EE6CK,eAAA;EACA,eAAA;AFqIpB;;AG1LA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AH6LJ;AG3LI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EHSJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EGNtB,sBAAA;EACA,WAAA;AH+LR;AG5LI;EACI,aAAA;EACA,QAAA;AH8LR;AG5LQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iDAAA;AH8LZ;AG5LY;EACI,sBAAA;AH8LhB;AG5LY;EACI,qBAAA;AH8LhB;AGzLI;EACI,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AH2LR;AGxLI;EACI;IACI,wBAAA;IACA,YAAA;EH0LV;EGxLM;IACI,4BAAA;IACA,UAAA;EH0LV;AACF;AGvLI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;AHyLR;AGvLQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AHyLZ;AGtLQ;EHpDJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EGuDlB,eAAA;AH0LZ;AGxLY;EACI,aAAA;AH0LhB;AGvLY;EACI,SAAA;AHyLhB;AGtLY;EACI,eAAA;EACA,iBAAA;AHwLhB;;AGlLA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AHqLJ;AGnLI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EHxFJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAiR9B;;AGnLA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;AHsLJ;;AGnLA;EACI,aAAA;AHsLJ;AGpLI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EHzGJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EAO1B,YGqGsB;EHpGtB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EGgGI,yBHxHO;EGyHP,gBAAA;EACA,kBAAA;AH8LR;AG5LQ;EACI,yBH5HM;AA0TlB;AG3LQ;EACI,yBH/HO;AA4TnB;AG1LQ;EACI,YAAA;EACA,WAAA;AH4LZ;AGzLQ;EACI,WAAA;EACA,eAAA;EACA,sCHzII;EG0IJ,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AH2LZ;AGzLY;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sEAAA;AH2LhB;AGvLQ;EACI,UAAA;EACA,mBAAA;AHyLZ;;AGpLA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,cH/Kc;AAsWlB;AGrLI;EHtKA,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAiW9B;AGtLI;EH1KA,aAAA;EACA,uBAFc;EAGd,mBAH0B;EG6KtB,cHxLO;AAkXf;AGtLI;EHhLA,aAAA;EACA,uBAFc;EAGd,mBAH0B;EGmLtB,iBAAA;AH0LR;AGxLQ;EH9KJ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EG0KQ,eAAA;EACA,cHnMG;AAmYf;AG9LY;EACI,cHrME;AAqYlB;;AG1LA;EACI;IACI,UAAA;EH6LN;EG1LE;IACI,UAAA;EH4LN;EGzLE;IACI,UAAA;EH2LN;AACF;AI3ZA;EACI,eAAA;EACA,gBAAA;EACA,cJMW;EILX,qBAAA;EACA,YAAA;EJgBA,aAAA;EACA,2BIhBgB;EJiBhB,mBAH0B;EIb1B,kBAAA;AJ+ZJ;AI7ZI;EACI,wCJHO;EIIP,yBJFO;AAiaf;AI5ZI;EACI,eAAA;EACA,iBAAA;AJ8ZR;;AI1ZA;EACI,aAAA;EACA,8BAAA;AJ6ZJ;AI3ZI;EACI,yBJjBU;EIkBV,YAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EJZJ,kDAAA;EIcI,eAAA;EACA,UAAA;AJ6ZR;AIvZQ;EAEI,eAAA;AJwZZ;AIrZQ;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AJuZZ;AIrZY;EACI,YAAA;AJuZhB;AInZQ;EACI,eAAA;EJjCR,aAAA;EACA,uBAFc;EAGd,mBAH0B;EIoClB,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,cJtDG;EIuDH,yBJxDM;EASd,kDAAA;EIiDQ,oBAAA;AJuZZ;AIrZY;EACI,WAAA;EACA,oBAAA;AJuZhB;AIlZI;EAEI,0BAAA;EACA,oBAAA;AJmZR;AIhZI;EAEI,6BAAA;EACA,oBAAA;AJiZR;;AI7YA;EACI,YAAA;EJpEA,aAAA;EACA,uBAFc;EAGd,mBAH0B;AAwd9B;;AK5eA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ELaA,gDAAA;EKXA,aAAA;AL+eJ;AK7eI;ELaA,aAAA;EACA,uBKZoB;ELapB,gBKb4B;EACxB,mBAAA;ALgfR;AK9eQ;EACI,eAAA;EACA,SAAA;ALgfZ;AK7eQ;EACI,cAAA;AL+eZ;AK5eQ;EACI,cLdG;EKeH,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AL8eZ;AK5eY;EACI,gBAAA;EACA,YAAA;AL8ehB;AKzeI;ELfA,aAAA;EACA,uBAFc;EAGd,mBAH0B;EKkBtB,qBLzBM;AAsgBd;AK3eQ;EACI,aAAA;AL6eZ;AKzeI;EACI,sBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AL2eR;AKzeQ;EACI,kBAAA;AL2eZ;AKzeY;EACI,YAAA;EACA,uBAAA;EACA,eAAA;AL2ehB;AKxeY;EACI,YAAA;EACA,eAAA;EACA,sCLnDA;EKoDA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AL0ehB;AKxegB;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sEAAA;AL0epB;AKteY;EACI,kBAAA;ALwehB;AKtegB;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,+CLxFD;EKyFC,iBAAA;EACA,eAAA;EACA,kBAAA;ALwepB;AKregB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cL/FL;AAskBf;AKneY;ELvFR,aAAA;EACA,sBKuF4B;ELtF5B,mBAH0B;EK0Fd,eAAA;EACA,qBLlGF;EKmGE,eAAA;ALuehB;AKregB;EACI,aAAA;ALuepB;AKleQ;EACI,YAAA;EACA,gBAAA;ELrGR,aAAA;EACA,oBKqGwB;ELpGxB,mBAH0B;AA6kB9B;AKpeY;EACI,cLrHD;EKsHC,qBAAA;EACA,eAAA;ALsehB;AKpegB;EACI,0BAAA;ALsepB;AKjeQ;EACI,YAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ALmeZ;AKheQ;EAEI,6CL9IM;EK+IN,wCL9IG;AA+mBf;AK/dY;EACI,yBL9IE;AA+mBlB;AK9dY;EACI,yBLjJG;AAinBnB;AK5dQ;EAEI,mDL7JO;EK8JP,WAAA;EACA,YAAA;AL6dZ;AK1dQ;ELlJJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EKsJlB,6CAAA;EACA,sBAAA;EACA,kCLtKM;EKuKN,gBAAA;AL6dZ;AK3dY;EACI,mDL3KG;AAwoBnB;AK1dY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AL4dhB;;AMlpBA;EACI,gBAAA;ANqpBJ;;AMlpBA;EACI,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ANqpBJ;AMnpBI;EACI,WAAA;EACA,mBNJU;AAypBlB;AMlpBI;EACI,kBAAA;EACA,mBNbU;AAiqBlB;AMjpBI;EACI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ENfJ,kDAAA;AAmqBJ;AMjpBQ;EACI,qBAAA;EACA,YAAA;ANmpBZ;AMjpBY;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;ANmpBhB;AMjpBgB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;ANmpBpB;AMhpBgB;EACI,WAAA;EACA,YAAA;ANkpBpB;AM7oBY;ENvCR,aAAA;EACA,uBAFc;EAGd,mBAH0B;EM0Cd,YAAA;ANipBhB;AM7oBQ;EACI,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AN+oBZ;AM7oBY;EACI,qBAAA;EACA,WAAA;AN+oBhB;AM5oBoB;EACI,YAAA;AN8oBxB;AM3oBoB;EACI,mBAAA;AN6oBxB;AMtoBQ;EN9DJ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EM0DQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;AN8oBZ;;AOhvBI;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;APmvBR;AOjvBQ;EACI,YAAA;EACA,eAAA;EACA,sCPGI;EOFJ,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;APmvBZ;AOjvBY;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sEAAA;APmvBhB;AO/uBQ;EACI,UAAA;EACA,mBAAA;APivBZ;;AO5uBA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,cPtCW;EOuCX,sBAAA;EP/BA,mDAAA;AA+wBJ;AO7uBI;EACI,cP1CU;EAWd,aAAA;EACA,uBAFc;EAGd,mBAH0B;EOkCtB,YAAA;APivBR;AO9uBI;EACI,UAAA;EACA,YAAA;APgvBR;AO9uBQ;EACI,gBAAA;EPzCR,aAAA;EACA,uBAFc;EAGd,mBAH0B;EO4ClB,sBAAA;APkvBZ;AOhvBY;EACI,gBAAA;EACA,eAAA;APkvBhB;AO9uBY;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;APgvBhB;AO3uBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AP6uBR;AO3uBQ;EP1DJ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EOsDQ,gBAAA;EACA,qBP3EE;EO4EF,mDPpFO;EOqFP,YAAA;EACA,YAAA;EACA,kBAAA;EP3ER,kDAAA;AA+zBJ;AOjvBY;EACI,WAAA;EACA,gCPpFF;EOqFE,gBAAA;EACA,eAAA;APmvBhB;AO9uBI;EACI,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,6CAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EP5FJ,aAAA;EACA,uBAFc;EAGd,mBAH0B;EO+FtB,sBAAA;EPlGJ,kDAAA;AAq1BJ;AOhvBQ;EACI,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EP/FR,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EO2FQ,WAAA;APwvBZ;AOrvBQ;EACI,UAAA;EP3GR,aAAA;EACA,6BO2GwB;EP1GxB,mBAH0B;EO8GlB,gBAAA;APyvBZ;AOvvBY;EACI,WAAA;EP1GZ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EOsGY,YAAA;EACA,YAAA;EACA,kBAAA;AP+vBhB;AO5vBY;EACI,qBPhIF;EOiIE,gBAAA;AP8vBhB;AO5vBgB;EACI,gCPpIN;EOqIM,WAAA;AP8vBpB;AOzvBgB;EACI,yBP/IL;EOgJK,WAAA;AP2vBpB;;AOpvBA;EP3II,aAAA;EACA,uBAFc;EAGd,mBAH0B;EO8I1B,sBAAA;EACA,gBAAA;APyvBJ;AOvvBI;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;APyvBR;AOrvBI;EACI,kBAAA;EACA,YAAA;APuvBR;AOrvBQ;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;APuvBZ;AOpvBQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;APsvBZ;AOpvBY;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;APsvBhB;AOpvBgB;EAEI,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;APqvBpB;AOlvBgB;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;APovBpB;AOjvBgB;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cPnNL;EOoNK,iBAAA;APmvBpB;AO/uBY;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,+BAAA;APivBhB;AO7uBQ;EACI,cAAA;AP+uBZ;AO5uBQ;EACI,UAAA;AP8uBZ;AOxuBQ;EPhOJ,SADgB;EAEhB,SAFuB;EAGvB,UAH8B;EAI9B,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EO4NQ,gBAAA;EACA,eAAA;EACA,cAAA;APgvBZ;AO9uBY;EACI,gCAAA;APgvBhB;AO5uBgB;EACI,gBAAA;AP8uBpB;AOzuBQ;EACI,gBAAA;EACA,cPrQG;AAg/Bf;AOzuBY;EACI,SAAA;EACA,eAAA;AP2uBhB;AOvuBQ;EACI,UAAA;EACA,gBAAA;EACA,qCAAA;APyuBZ;AOtuBQ;EACI,UAAA;EACA,sDAAA;EACA,kBAAA;APwuBZ;;AQvgCA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;AR0gCJ;;AQvgCA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AR0gCJ;;ASnhCA;EACI;IACI,sBAAA;IACA,mBAAA;IACA,eAAA;ETshCN;ESnhCE;IACI,cAAA;IACA,gBAAA;IACA,YAAA;ITQJ,aAAA;IACA,uBAFc;IAGd,mBAH0B;ISLtB,sBAAA;ETuhCN;ESrhCM;IACI,kBAAA;IACA,mBAAA;ETuhCV;ESphCM;IACI,gBAAA;ETshCV;AACF;ASjhCA;EACI;IACI,WAAA;IACA,gBAAA;IACA,YAAA;IACA,qBAAA;ETmhCN;ESjhCM;IACI,sBAAA;IACA,uBAAA;ETmhCV;AACF;AS9gCA;EACI;IACI,UAAA;ETghCN;ES9gCM;IACI,eAAA;ETghCV;ES9gCU;IACI,gBAAA;ETghCd;ES3gCU;IACI,eAAA;IACA,kBAAA;ET6gCd;ES1gCU;IACI,YAAA;IACA,WAAA;IACA,iBAAA;ET4gCd;AACF;AStgCA;EACI;IACI,qCAAA;IACA,kBAAA;ETwgCN;AACF;ASrgCA;EACI;IACI,qCAAA;IACA,kBAAA;ETugCN;AACF;ASpgCA;EACI;IACI,0BAAA;IACA,kBAAA;ETsgCN;ESpgCM;IACI,YAAA;ETsgCV;AACF;ASjgCA;EACI;IACI,yBAAA;IACA,aAAA;ETmgCN;ESjgCM;IACI,WAAA;ETmgCV;ESjgCU;IACI,WAAA;ETmgCd;ES//Bc;IACI,wBAAA;ETigClB;AACF;AS1/BA;EACI;IACI,gBAAA;ET4/BN;AACF;ASx/BA;EAEQ;IACI,eAAA;IACA,WAAA;IACA,YAAA;ETy/BV;AACF;ASp/BA;EACI;IACI,sCAAA;ETs/BN;ESp/BM;IACI,WAAA;IACA,YAAA;ETs/BV;ESn/BM;IACI,YAAA;IACA,YAAA;ETq/BV;AACF","sourcesContent":["@font-face {\n    font-family: Cubic;\n    src: url(./assets/Cubic_11_1.013_R.woff2);\n}\n\n$content-bg-color: #c7c7c7e8;\n$header-bg-color: #000000e8;\n$header-color: #ffffffe8;\n$navbar-bg-color: #ffffff;\n$navbar-color: #4b4b4b;\n$btn-hover-color: #343434;\n$btn-active-color: #161616;\n$tooltip-color: rgba(0, 0, 0, 0.555);\n$alert-color: rgb(212, 0, 0);\n$scrollbar-color: #9e9e9e;\n\n@mixin box-shadow($v: 0, $h: 0, $b: 5px) {\n    box-shadow: $v $h $b 1px rgba(113, 113, 113, 0.5);\n}\n\n@mixin d-flex($j: center, $a: center) {\n    display: flex;\n    justify-content: $j;\n    align-items: $a;\n}\n\n@mixin btn-init($m: 0, $b: 0, $p: 0) {\n    margin: $m;\n    border: $b;\n    padding: $p;\n    outline: none;\n    cursor: pointer;\n    font-family: 'Cubic';\n    background-color: #00000000;\n}\n\nhtml,\nbody {\n    background-color: $content-bg-color;\n    font-family: Cubic;\n    margin: 0;\n    height: 100%;\n}\n\n#root {\n    height: 100%;\n}\n\n\n@import \"./scss/home.scss\";\n@import \"./scss/header.scss\";\n@import \"./scss/canvas.scss\";\n@import \"./scss/section.scss\";\n@import \"./scss/form.scss\";\n@import \"./scss/project.scss\";\n@import \"./scss/editPanel.scss\";\n@import \"./scss/tutorial.scss\";\n@import \"./scss/responsive.scss\";",".home {\n    background-color: $header-bg-color;\n    min-height: calc(100vh - 50px);\n    padding-bottom: 30px;\n\n    .home-panel {\n        margin-left: 50px;\n        height: 480px;\n\n        .home-info {\n            color: #fff;\n            margin-bottom: 80px;\n            width: 200px;\n\n            h3 {\n                font-weight: 500;\n            }\n        }\n\n        .home-btn {\n            @include d-flex(space-between);\n            margin: auto;\n            margin-top: 60px;\n\n            .home-btn-roll {\n                button {\n                    @include btn-init;\n                    width: 50px;\n                    height: 50px;\n                    border: 3px solid $navbar-bg-color;\n                    border-radius: 5px;\n                    color: $navbar-bg-color;\n                    font-size: 20px;\n                    @include d-flex;\n\n                    &:hover {\n                        background-color: $navbar-bg-color;\n                        color: $header-bg-color;\n                        transition: all 0.3s;\n                    }\n\n                    &:disabled {\n                        opacity: 0.5;\n                        cursor: not-allowed;\n                    }\n                }\n            }\n\n            .home-btn-signup,\n            .home-btn-play {\n                width: 80px;\n                height: 50px;\n                background-color: $header-bg-color;\n                border: 3px solid $navbar-bg-color;\n                border-radius: 5px;\n                font-size: 14px;\n\n                &:hover {\n                    background-color: $navbar-bg-color;\n                }\n\n                a {\n                    width: 100%;\n                    height: 100%;\n                    text-decoration: none;\n                    color: $navbar-bg-color;\n                    @include d-flex;\n\n                    &:hover {\n                        color: $header-bg-color;\n                        font-weight: 700;\n                        font-size: 16px;\n                        transition: all 0.5s;\n                    }\n                }\n            }\n        }\n\n    }\n}\n\n.keyboard {\n    display: grid;\n    grid-template-rows: 55px;\n    grid-template-columns: repeat(8, 25px);\n    grid-row-gap: 20px;\n    justify-items: space-between;\n    align-items: center;\n    margin: auto;\n\n    div {\n        background-color: #fff;\n        border-radius: 10px;\n        @include d-flex;\n        font-size: 24px;\n        border-bottom: 5px solid $content-bg-color;\n    }\n\n    .arrow {\n        font-weight: 700;\n        width: 50px;\n        height: 50px;\n    }\n\n    .arrow-left {\n        grid-column-start: 2;\n    }\n\n    .arrow-right {\n        grid-column-start: 6;\n    }\n\n    .space {\n        width: 200px;\n        height: 50px;\n        grid-column-start: 1;\n    }\n}",".header {\n    background-color: $header-bg-color;\n    width: 100%;\n    height: 50px;\n    @include d-flex;\n\n    .header-container {\n        width: 90%;\n        @include d-flex(space-between);\n\n        a {\n            color: $header-color;\n            font-size: 25px;\n            cursor: pointer;\n            text-decoration: none;\n\n            span {\n                margin-left: 10px;\n            }\n        }\n\n        div {\n            @include d-flex;\n\n            img {\n                height: 30px;\n                width: 30px;\n                border-radius: 30px;\n                margin-right: 15px;\n            }\n\n            span {\n                color: $header-color;\n                font-size: 20px;\n                margin-right: 40px;\n                cursor: default;\n            }\n\n            button {\n                border: 0;\n                background-color: #00000000;\n\n                i {\n                    color: $header-color;\n                    font-size: 30px;\n                    cursor: pointer;\n                }\n            }\n\n            a {\n                i {\n                    color: $header-color;\n                    font-size: 30px;\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n}","#game-window {\n    width: 640px;\n    height: 480px;\n    border: 5px solid black;\n    position: relative;\n\n    .game-loading {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #000000e8;\n        @include d-flex;\n        flex-direction: column;\n        z-index: 10;\n    }\n\n    .game-loading-blocks {\n        display: flex;\n        gap: 8px;\n\n        span {\n            display: block;\n            width: 16px;\n            height: 16px;\n            background: #fff;\n            animation: pixel-bounce 0.6s ease-in-out infinite;\n\n            &:nth-child(2) {\n                animation-delay: 0.15s;\n            }\n            &:nth-child(3) {\n                animation-delay: 0.3s;\n            }\n        }\n    }\n\n    .game-loading-text {\n        font-family: Cubic, serif;\n        font-size: 24px;\n        color: #c7c7c7;\n        margin-top: 16px;\n        letter-spacing: 2px;\n    }\n\n    @keyframes pixel-bounce {\n        0%, 100% {\n            transform: translateY(0);\n            opacity: 0.3;\n        }\n        50% {\n            transform: translateY(-12px);\n            opacity: 1;\n        }\n    }\n\n    #score {\n        position: absolute;\n        top: 10px;\n        left: 10px;\n        font-family: Cubic, serif;\n        font-size: 32px;\n        color: white;\n        background-color: rgba(255, 255, 255, 0);\n        display: flex;\n\n        img {\n            width: 45px;\n            height: 45px;\n            margin-right: 5px;\n        }\n\n        div {\n            @include d-flex;\n            margin-top: 5px;\n\n            span {\n                margin: 0 5px;\n            }\n\n            p {\n                margin: 0;\n            }\n\n            .score-slash {\n                font-size: 20px;\n                padding-top: 10px;\n            }\n        }\n    }\n}\n\n#editor-window {\n    width: 736px;\n    height: 480px;\n    border: 5px solid black;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    position: relative;\n\n    #save-hint {\n        position: absolute;\n        font-size: 48px;\n        color: #fff;\n        left: 96px;\n        width: 640px;\n        height: 480px;\n        @include d-flex;\n    }\n}\n\n.container-edit {\n    display: flex;\n    position: relative;\n    width: 100%;\n}\n\n.container-btn-group {\n    height: 480px;\n\n    .container-btn {\n        height: 32px;\n        width: 32px;\n        border-radius: 8px;\n        @include d-flex;\n        @include btn-init(10px);\n        background-color: $navbar-color;\n        margin-top: 15px;\n        position: relative;\n\n        &:hover {\n            background-color: $btn-hover-color;\n        }\n\n        &:active {\n            background-color: $btn-active-color;\n        }\n\n        img {\n            height: 20px;\n            width: 20px;\n        }\n\n        .tooltiptext {\n            width: 50px;\n            font-size: 14px;\n            background-color: $tooltip-color;\n            color: #fff;\n            text-align: center;\n            padding: 5px;\n            border-radius: 6px;\n            position: absolute;\n            z-index: 1;\n            left: 120%;\n            opacity: 0;\n            transition: opacity 0.8s;\n            visibility: hidden;\n            font-family: Cubic;\n\n            &::after {\n                content: \" \";\n                position: absolute;\n                top: 50%;\n                right: 100%;\n                margin-top: -5px;\n                border-width: 5px;\n                border-style: solid;\n                border-color: transparent $tooltip-color transparent transparent;\n            }\n        }\n\n        &:hover .tooltiptext {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n.game-info {\n    margin-right: 30px;\n    height: 480px;\n    width: 200px;\n    color: $btn-hover-color;\n\n    h1 {\n        @include d-flex;\n    }\n\n    h3 {\n        @include d-flex;\n        color: $navbar-color;\n    }\n\n\n    .game-refresh {\n        @include d-flex;\n        margin-top: 100px;\n\n        button {\n            @include btn-init;\n            font-size: 32px;\n            color: $navbar-color;\n\n            &:hover {\n                color: $btn-hover-color;\n            }\n        }\n    }\n}\n\n@keyframes fadein {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}","%navbar-link {\n    font-size: 20px;\n    font-weight: 700;\n    color: $navbar-color;\n    text-decoration: none;\n    height: 100%;\n    @include d-flex(flex-start);\n    padding-left: 40px;\n\n    &:hover {\n        color: $header-color;\n        background-color: $navbar-color;\n    }\n\n    span {\n        font-size: 30px;\n        margin-left: 10px;\n    }\n}\n\n.section {\n    display: flex;\n    min-height: calc(100vh - 50px);\n\n    %navbar {\n        background-color: $navbar-bg-color;\n        width: 200px;\n        height: 100%;\n        display: flex;\n        flex-grow: 1;\n        @include box-shadow(3px);\n        position: fixed;\n        z-index: 1;\n\n        .navbar-link {\n            @extend %navbar-link;\n        }\n\n        .navbar-link-title {\n            @extend %navbar-link;\n            font-size: 30px;\n        }\n\n        ul {\n            list-style: none;\n            padding: 0;\n            width: 100%;\n\n            li {\n                height: 50px;\n            }\n        }\n\n        div {\n            cursor: pointer;\n            @include d-flex;\n            padding-right: 5px;\n            border-radius: 0 10px 10px 0;\n            height: 50px;\n            width: 30px;\n            position: absolute;\n            left: 200px;\n            top: calc(50% - 50px);\n            color: $navbar-color;\n            background-color: $navbar-bg-color;\n            @include box-shadow(5px);\n            transition: all 0.3s;\n\n            &:hover {\n                width: 40px;\n                transition: all 0.3s;\n            }\n        }\n    }\n\n    .open {\n        @extend %navbar;\n        transform: translateX(0px);\n        transition: all 0.5s;\n    }\n\n    .close {\n        @extend %navbar;\n        transform: translateX(-200px);\n        transition: all 0.5s;\n    }\n}\n\n.container {\n    flex-grow: 1;\n    @include d-flex;\n}",".sign-form {\n    width: 370px;\n    height: 420px;\n    background-color: #fff;\n    border-radius: 20px;\n    @include box-shadow(0);\n    padding: 30px;\n\n    >div {\n\n        @include d-flex(center, end);\n        margin-bottom: 15px;\n\n        h1 {\n            font-size: 30px;\n            margin: 0;\n        }\n\n        p {\n            margin: 0 10px;\n        }\n\n        .form-link {\n            color: $navbar-color;\n            text-decoration: none;\n            font-size: 18px;\n            text-align: center;\n            margin: 0;\n\n            &:hover {\n                font-weight: 600;\n                color: black;\n            }\n        }\n    }\n\n    >p {\n        @include d-flex;\n        color: $alert-color;\n\n        i {\n            margin: 0 5px;\n        }\n    }\n\n    form {\n        flex-direction: column;\n        height: 365px;\n        width: 280px;\n        margin: auto;\n\n        label {\n            position: relative;\n\n            p {\n                width: 240px;\n                margin: 10px 0 5px 10px;\n                font-size: 14px;\n            }\n\n            .tooltiptext {\n                width: 180px;\n                font-size: 14px;\n                background-color: $tooltip-color;\n                color: #fff;\n                text-align: center;\n                padding: 5px;\n                border-radius: 6px;\n                position: absolute;\n                z-index: 1;\n                top: 30px;\n                left: 290px;\n                font-family: Cubic;\n\n                &::after {\n                    content: \" \";\n                    position: absolute;\n                    top: 50%;\n                    right: 100%;\n                    margin-top: -5px;\n                    border-width: 5px;\n                    border-style: solid;\n                    border-color: transparent $tooltip-color transparent transparent;\n                }\n            }\n\n            .input-box {\n                position: relative;\n\n                input {\n                    height: 35px;\n                    width: 246px;\n                    border-radius: 10px;\n                    border-color: $content-bg-color;\n                    padding: 0px 15px;\n                    font-size: 16px;\n                    font-family: Cubic;\n                }\n\n                i {\n                    position: absolute;\n                    top: 10px;\n                    right: 10px;\n                    cursor: pointer;\n                    color: $navbar-color;\n                }\n            }\n\n            span {\n                @include d-flex(start);\n                font-size: 12px;\n                color: $alert-color;\n                margin-top: 5px;\n\n                i {\n                    margin: 0 5px;\n                }\n            }\n        }\n\n        .form-link-pw {\n            width: 250px;\n            margin: 5px 15px;\n            @include d-flex(end);\n\n            a {\n                color: $navbar-color;\n                text-decoration: none;\n                font-size: 12px;\n\n                &:hover {\n                    text-decoration: underline;\n                }\n            }\n        }\n\n        %form-btn {\n            height: 40px;\n            width: 280px;\n            border: 0;\n            border-radius: 10px;\n            cursor: pointer;\n            font-family: Cubic;\n            margin: 20px 0 0 0;\n        }\n\n        .form-btn {\n            @extend %form-btn;\n            background-color: $header-bg-color;\n            color: $header-color;\n\n            &:hover {\n                background-color: $btn-hover-color;\n            }\n\n            &:active {\n                background-color: $btn-active-color;\n            }\n        }\n\n        .form-btn-disabled {\n            @extend %form-btn;\n            background-color: $content-bg-color;\n            color: #fff;\n            cursor: auto;\n        }\n\n        .form-btn-other {\n            @extend %form-btn;\n            @include d-flex;\n            border: 2px solid $header-bg-color;\n            background-color: #fff;\n            color: $header-bg-color;\n            font-weight: 600;\n\n            &:hover {\n                background-color: $content-bg-color;\n            }\n\n            img {\n                width: 20px;\n                height: 20px;\n                margin-right: 10px;\n            }\n        }\n\n    }\n}",".project-title {\n    margin-top: 50px;\n}\n\n.project-list {\n    list-style: none;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: 210px;\n    grid-gap: 20px;\n    max-height: 90%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-right: 10px;\n    padding-left: 50px;\n\n    &::-webkit-scrollbar {\n        width: 10px;\n        background: $scrollbar-color;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background: $btn-hover-color;\n    }\n\n    li {\n        background-color: #fff;\n        width: 200px;\n        height: 200px;\n        border: 2px solid black;\n        border-radius: 10px;\n        cursor: pointer;\n        @include box-shadow(0, 3px);\n\n        a {\n            text-decoration: none;\n            color: black;\n\n            .project-img {\n                width: 100%;\n                height: 150px;\n                border-radius: 8px 8px 0 0;\n                overflow: hidden;\n                position: relative;\n\n                .img-icon {\n                    position: absolute;\n                    top: 64px;\n                    left: 84px;\n                    visibility: hidden;\n                }\n\n                .img-main {\n                    width: 100%;\n                    height: 100%;\n                }\n\n            }\n\n            .project-name {\n                @include d-flex;\n                height: 48px;\n            }\n        }\n\n        &:hover {\n            box-shadow: none;\n            background-color: black;\n            margin-top: 3px;\n            margin-bottom: -3px;\n\n            a {\n                text-decoration: none;\n                color: #fff;\n\n                .project-img {\n                    .img-main {\n                        opacity: 0.5;\n                    }\n\n                    .img-icon {\n                        visibility: visible;\n                    }\n                }\n            }\n\n        }\n\n        button {\n            @include btn-init;\n            width: 100%;\n            height: 100%;\n            border-radius: 8px;\n            font-size: 32px;\n            background-color: #fff;\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -o-user-select: none;\n            user-select: none;\n        }\n    }\n}","%tool-tip {\n    i {\n        margin-right: 5px;\n        font-size: 12px;\n        position: relative;\n\n        .tooltiptext {\n            width: 150px;\n            font-size: 14px;\n            background-color: $tooltip-color;\n            color: #fff;\n            text-align: center;\n            padding: 10px;\n            border-radius: 6px;\n            position: absolute;\n            z-index: 1;\n            top: -12px;\n            right: 200%;\n            opacity: 0;\n            transition: opacity 0.8s;\n            visibility: hidden;\n            font-family: Cubic;\n\n            &::after {\n                content: \" \";\n                position: absolute;\n                top: 50%;\n                left: 100%;\n                margin-top: -5px;\n                border-width: 5px;\n                border-style: solid;\n                border-color: transparent transparent transparent $tooltip-color;\n            }\n        }\n\n        &:hover .tooltiptext {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n#edit-panel {\n    position: absolute;\n    right: 0;\n    width: 200px;\n    height: 100%;\n    color: $navbar-color;\n    background-color: #fff;\n    @include box-shadow(-1px);\n\n    h2 {\n        color: $btn-hover-color;\n        @include d-flex;\n        margin: 30px;\n    }\n\n    form {\n        width: 80%;\n        margin: auto;\n\n        >div {\n            margin-top: 25px;\n            @include d-flex;\n            flex-direction: column;\n\n            label {\n                font-weight: 700;\n                font-size: 16px;\n                @extend %tool-tip;\n            }\n\n            input {\n                width: 100px;\n                margin-top: 10px;\n                font-family: Cubic;\n            }\n        }\n    }\n\n    .edit-delete {\n        position: absolute;\n        bottom: 30px;\n        right: 40px;\n\n        button {\n            @include btn-init;\n            font-weight: 700;\n            color: $alert-color;\n            background-color: $content-bg-color;\n            height: 30px;\n            width: 120px;\n            border-radius: 8px;\n            @include box-shadow(0, 1px, 1px);\n\n            &:hover {\n                color: #fff;\n                background-color: $alert-color;\n                box-shadow: none;\n                margin-top: 2px;\n            }\n        }\n    }\n\n    .delete-window {\n        position: fixed;\n        top: calc(50% - 72px);\n        left: calc(50% - 172px);\n        background-color: #000000e8;\n        color: #fff;\n        border: 3px solid #fff;\n        width: 350px;\n        height: 150px;\n        border-radius: 10px;\n        @include d-flex;\n        flex-direction: column;\n        @include box-shadow(0, 3px);\n\n        .delete-close {\n            position: absolute;\n            top: calc(50% - 60px);\n            left: calc(50% + 150px);\n            cursor: pointer;\n            @include btn-init;\n            color: #fff;\n        }\n\n        .delete-btns {\n            width: 80%;\n            @include d-flex(space-around);\n            margin-top: 20px;\n\n            button {\n                color: #fff;\n                @include btn-init;\n                width: 100px;\n                height: 20px;\n                border-radius: 3px;\n            }\n\n            .delete-yes {\n                color: $alert-color;\n                font-weight: 700;\n\n                &:hover {\n                    background-color: $alert-color;\n                    color: #fff;\n                }\n            }\n\n            .delete-no {\n                &:hover {\n                    background-color: $navbar-color;\n                    color: #fff;\n                }\n            }\n        }\n    }\n}\n\n.publish-switch {\n    @include d-flex;\n    flex-direction: column;\n    margin-top: 25px;\n\n    .publish-title {\n        margin-bottom: 10px;\n        font-weight: 700;\n        font-size: 16px;\n        @extend %tool-tip;\n    }\n\n    .onoffswitch {\n        position: relative;\n        width: 100px;\n\n        input {\n            position: absolute;\n            opacity: 0;\n            pointer-events: none;\n        }\n\n        label {\n            display: block;\n            overflow: hidden;\n            cursor: pointer;\n            border: 2px solid $scrollbar-color;\n            border-radius: 20px;\n\n            .onoffswitch-inner {\n                display: block;\n                width: 200%;\n                margin-left: -100%;\n                transition: margin 0.3s ease-in 0s;\n\n                &:before,\n                &:after {\n                    display: block;\n                    float: left;\n                    width: 50%;\n                    height: 30px;\n                    padding: 0;\n                    line-height: 30px;\n                    font-size: 14px;\n                    color: white;\n                    font-weight: bold;\n                    box-sizing: border-box;\n                }\n\n                &:before {\n                    content: \"Public\";\n                    padding-left: 15px;\n                    background-color: #1099bb;\n                    color: #FFFFFF;\n                }\n\n                &:after {\n                    content: \"Draft\";\n                    padding-right: 15px;\n                    background-color: #EEEEEE;\n                    color: $navbar-color;\n                    text-align: right;\n                }\n            }\n\n            .onoffswitch-switch {\n                display: block;\n                width: 18px;\n                margin: 6px;\n                background: #FFFFFF;\n                position: absolute;\n                top: 0;\n                bottom: 0;\n                right: 64px;\n                border: 2px solid $scrollbar-color;\n                border-radius: 20px;\n                transition: all 0.3s ease-in 0s;\n            }\n        }\n\n        input:checked+label .onoffswitch-inner {\n            margin-left: 0;\n        }\n\n        input:checked+label .onoffswitch-switch {\n            right: 0px;\n        }\n    }\n\n    .publish-copy {\n\n        button {\n            @include btn-init;\n            font-weight: 700;\n            font-size: 12px;\n            color: #1099bb;\n\n            &:hover {\n                border-bottom: 2px solid #1099bb;\n            }\n\n            span {\n                i {\n                    margin-left: 5px;\n                }\n            }\n        }\n\n        .copied {\n            margin-top: 15px;\n            color: $navbar-color;\n\n            &:hover {\n                border: 0;\n                cursor: default;\n            }\n        }\n\n        .appear {\n            opacity: 1;\n            margin-top: 15px;\n            transition: opacity 0.5s, margin 0.5s;\n        }\n\n        .disappear {\n            opacity: 0;\n            transition: visibility 0.5s, opacity 0.5s, margin 0.5s;\n            visibility: hidden;\n        }\n    }\n}",".videobox {\n    position: relative;\n    width: 60%;\n    height: 0;\n    padding-bottom: 33.75%;\n}\n\n.videobox iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}","// ── Responsive: prevent overflow on small screens ──\n\n// Home page: stack vertically on narrow screens\n@media (max-width: 960px) {\n    .container.home {\n        flex-direction: column;\n        align-items: center;\n        padding: 20px 0;\n    }\n\n    .home .home-panel {\n        margin-left: 0;\n        margin-top: 20px;\n        height: auto;\n        @include d-flex;\n        flex-direction: column;\n\n        .home-info {\n            text-align: center;\n            margin-bottom: 30px;\n        }\n\n        .home-btn {\n            margin-top: 30px;\n        }\n    }\n}\n\n// Game window: scale down on narrow screens\n@media (max-width: 680px) {\n    #game-window {\n        width: 100%;\n        max-width: 640px;\n        height: auto;\n        aspect-ratio: 640 / 480;\n\n        canvas {\n            width: 100% !important;\n            height: 100% !important;\n        }\n    }\n}\n\n// Header: shrink text and spacing\n@media (max-width: 600px) {\n    .header .header-container {\n        width: 95%;\n\n        a {\n            font-size: 20px;\n\n            span {\n                margin-left: 5px;\n            }\n        }\n\n        div {\n            span {\n                font-size: 14px;\n                margin-right: 10px;\n            }\n\n            img {\n                height: 24px;\n                width: 24px;\n                margin-right: 8px;\n            }\n        }\n    }\n}\n\n// Project grid: fewer columns on smaller screens\n@media (max-width: 1100px) {\n    .project-list {\n        grid-template-columns: repeat(3, 1fr);\n        padding-left: 30px;\n    }\n}\n\n@media (max-width: 800px) {\n    .project-list {\n        grid-template-columns: repeat(2, 1fr);\n        padding-left: 20px;\n    }\n}\n\n@media (max-width: 500px) {\n    .project-list {\n        grid-template-columns: 1fr;\n        padding-left: 10px;\n\n        li {\n            width: 180px;\n        }\n    }\n}\n\n// Sign in/up form: fit narrow screens\n@media (max-width: 480px) {\n    .sign-form {\n        width: calc(100vw - 80px);\n        padding: 20px;\n\n        form {\n            width: 100%;\n\n            %form-btn {\n                width: 100%;\n            }\n\n            label {\n                .input-box input {\n                    width: calc(100% - 30px);\n                }\n            }\n        }\n    }\n}\n\n// Editor: allow horizontal scroll on narrow screens\n@media (max-width: 800px) {\n    .container-edit {\n        overflow-x: auto;\n    }\n}\n\n// Navbar sidebar: overlay instead of push on narrow screens\n@media (max-width: 700px) {\n    .section {\n        .open, .close {\n            position: fixed;\n            z-index: 10;\n            height: 100%;\n        }\n    }\n}\n\n// Keyboard widget on home\n@media (max-width: 400px) {\n    .keyboard {\n        grid-template-columns: repeat(8, 20px);\n\n        .arrow {\n            width: 40px;\n            height: 40px;\n        }\n\n        .space {\n            width: 160px;\n            height: 40px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
